import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import "./index.scss"
import EAFormEmbed from "../EAFormEmbed"

export default function HomeHero({ component }) {
  const { headline, intro, everyActionFormLink } = component
  const { hasBackgroundImage, backgroundColor, image } = component.background[0]
  const bgImage = hasBackgroundImage ? getImage(image) : null
  return (
    <section
      data-datocms-noindex
      className="home-hero"
      style={{
        backgroundColor:
          hasBackgroundImage === false ? backgroundColor : "#fff",
      }}
    >
      {hasBackgroundImage && (
        <div className="home-hero__bg">
          <GatsbyImage image={bgImage} alt="" />
        </div>
      )}
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div
              className="home-hero__headline thick"
              dangerouslySetInnerHTML={{ __html: headline }}
            />
            <p className="intro">{intro}</p>
          </div>
          <div className="col-lg-1"></div>
          <div className="col-lg-5">
            {everyActionFormLink && (
              <EAFormEmbed formLink={everyActionFormLink} />
            )}
          </div>
        </div>
      </div>
    </section>
  )
}
